import { render, staticRenderFns } from "./SectionNosotros2.vue?vue&type=template&id=9adb9358&scoped=true&"
import script from "./SectionNosotros2.vue?vue&type=script&lang=js&"
export * from "./SectionNosotros2.vue?vue&type=script&lang=js&"
import style0 from "./SectionNosotros2.vue?vue&type=style&index=0&id=9adb9358&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9adb9358",
  null
  
)

export default component.exports